import { render, staticRenderFns } from "./BlocoHistoricoMonitoramento.vue?vue&type=template&id=0cb4a456&scoped=true&lang=pug"
import script from "./BlocoHistoricoMonitoramento.vue?vue&type=script&lang=js"
export * from "./BlocoHistoricoMonitoramento.vue?vue&type=script&lang=js"
import style0 from "./BlocoHistoricoMonitoramento.vue?vue&type=style&index=0&id=0cb4a456&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb4a456",
  null
  
)

export default component.exports